import { useLocation, useNavigate } from 'react-router-dom';
import { Home, Package, Handshake, User, Plus } from 'lucide-react';

const navItems = [
  { path: '/', icon: Home, label: 'Feed' },
  { path: '/locker', icon: Package, label: 'Locker' },
  { path: '/deals', icon: Handshake, label: 'Tratos' },
  { path: '/profile', icon: User, label: 'Perfil' },
];

const sora = { fontFamily: 'Sora, sans-serif' };

export default function DesktopSidebar() {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <aside data-testid="desktop-sidebar"
      className="hidden lg:flex flex-col w-[160px] shrink-0 h-[calc(100vh-48px)] sticky top-[48px] py-5 px-3"
      style={{ ...sora }}
    >
      <nav className="flex-1 space-y-0.5">
        {navItems.map(({ path, label }) => {
          const isActive = location.pathname === path || (path === '/' && location.pathname.startsWith('/item'));
          return (
            <button
              key={path}
              data-testid={`sidebar-nav-${label.toLowerCase()}`}
              onClick={() => navigate(path)}
              className="w-full text-left px-4 py-2.5 rounded-xl text-sm font-medium transition-all"
              style={{
                background: isActive ? '#f5c51815' : 'transparent',
                color: isActive ? '#f5c518' : '#888',
              }}
            >
              {label}
            </button>
          );
        })}
      </nav>

      <button
        data-testid="sidebar-publicar"
        onClick={() => navigate('/upload')}
        className="w-full flex items-center justify-center gap-1.5 py-3 rounded-xl text-sm font-bold active:scale-95 transition-transform"
        style={{
          background: 'linear-gradient(135deg, #f5c518, #d4a017)',
          color: '#000',
          fontFamily: 'Sora, sans-serif',
        }}
      >
        <Plus className="w-4 h-4" /> Publicar
      </button>
    </aside>
  );
}
